import React from 'react'
import PageHeader from '../MainPortfolio/PageHeader'
import Header from '../HeaderOne/Main'
import PortfolioPage from '../MainPortfolio/PortfolioPage'

function Main() {
  return (
    <>
      <Header />
      <PageHeader />
      <PortfolioPage />
    </>
  )
}

export default Main
